/* Gameday Stripes — theme interactions */
(function () {
  'use strict';
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const money = (cents) => {
    try {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' }).format(cents / 100);
    } catch (e) { return '$' + (cents / 100).toFixed(2); }
  };

  /* -------- Cart drawer -------- */
  const drawer = $('#CartDrawer');
  const overlay = $('[data-cart-overlay]');

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('open');
    overlay && overlay.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('no-scroll');
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('open');
    overlay && overlay.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('no-scroll');
  }

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-cart-toggle]')) { e.preventDefault(); openDrawer(); }
    if (e.target.closest('[data-cart-close]') || e.target.closest('[data-cart-overlay]')) closeDrawer();
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') { closeDrawer(); closeMenu(); } });

  function updateCartCount(count) {
    $$('[data-cart-count]').forEach((el) => {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  async function refreshDrawer(open = true) {
    try {
      const res = await fetch(`${window.location.pathname}?section_id=cart-drawer`);
      const text = await res.text();
      const html = new DOMParser().parseFromString(text, 'text/html');
      const newItems = html.querySelector('[data-cart-items]');
      const newFoot = html.querySelector('[data-cart-foot]');
      if (newItems && $('[data-cart-items]')) $('[data-cart-items]').innerHTML = newItems.innerHTML;
      if (newFoot && $('[data-cart-foot]')) {
        $('[data-cart-foot]').innerHTML = newFoot.innerHTML;
        $('[data-cart-foot]').hidden = newFoot.hidden;
      }
    } catch (e) { console.warn('cart refresh failed', e); }
    if (open) openDrawer();
  }

  async function addToCart(id, qty = 1) {
    const res = await fetch(window.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id, quantity: qty })
    });
    if (!res.ok) throw new Error('add failed');
    await getCartState();
    await refreshDrawer(true);
  }

  async function changeLine(key, qty) {
    const res = await fetch(window.routes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    });
    const cart = await res.json();
    updateCartCount(cart.item_count);
    await refreshDrawer(false);
  }

  async function getCartState() {
    try {
      const cart = await (await fetch(window.routes.cart_url + '.js')).json();
      updateCartCount(cart.item_count);
      return cart;
    } catch (e) { return null; }
  }

  /* Quick-add forms (product cards) */
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('.quick-add-form, [data-product-form]');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('[type="submit"]');
    const id = form.querySelector('[name="id"]').value;
    const qtyEl = form.querySelector('[name="quantity"]');
    const qty = qtyEl ? parseInt(qtyEl.value, 10) || 1 : 1;
    if (!id) return;
    const label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.dataset.loading = '1'; btn.textContent = 'Adding...'; }
    try {
      await addToCart(id, qty);
      if (btn) btn.textContent = 'Added ✓';
    } catch (err) {
      alert(window.cartStrings ? window.cartStrings.error : 'Error');
      if (btn) btn.textContent = label;
    } finally {
      setTimeout(() => { if (btn) { btn.disabled = false; delete btn.dataset.loading; btn.textContent = label; } }, 1200);
    }
  });

  /* Cart drawer qty + remove (delegated) */
  document.addEventListener('click', (e) => {
    const plus = e.target.closest('[data-qty-plus]');
    const minus = e.target.closest('[data-qty-minus]');
    const remove = e.target.closest('[data-remove]');
    if (plus || minus) {
      const wrap = e.target.closest('[data-qty]');
      const input = wrap.querySelector('[data-qty-input]');
      let v = parseInt(input.value, 10) || 1;
      v = plus ? v + 1 : Math.max(0, v - 1);
      changeLine(input.dataset.key, v);
    }
    if (remove) { e.preventDefault(); changeLine(remove.dataset.key, 0); }
  });

  /* -------- Mobile menu -------- */
  const mobileMenu = $('#MobileMenu');
  function openMenu() { if (mobileMenu) { mobileMenu.classList.add('open'); document.body.classList.add('no-scroll'); mobileMenu.setAttribute('aria-hidden', 'false'); } }
  function closeMenu() { if (mobileMenu) { mobileMenu.classList.remove('open'); document.body.classList.remove('no-scroll'); mobileMenu.setAttribute('aria-hidden', 'true'); } }
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-menu-toggle]')) { e.preventDefault(); openMenu(); }
    if (e.target.closest('[data-menu-close]')) closeMenu();
  });

  /* -------- Accordions (PDP) -------- */
  document.addEventListener('click', (e) => {
    const trig = e.target.closest('.accordion__trigger');
    if (!trig) return;
    const item = trig.closest('.accordion__item');
    const panel = item.querySelector('.accordion__panel');
    const isOpen = item.classList.toggle('open');
    panel.style.maxHeight = isOpen ? panel.scrollHeight + 'px' : '0px';
  });

  /* -------- Product page: variant selection + gallery -------- */
  $$('[data-product-root]').forEach((root) => {
    const variantsData = JSON.parse(root.querySelector('[data-variants-json]').textContent);
    const optionInputs = $$('[data-option-index]', root);
    const idInput = root.querySelector('[name="id"]');
    const priceEl = root.querySelector('[data-pdp-price]');
    const addBtn = root.querySelector('[data-add-btn]');
    const mainImg = root.querySelector('[data-main-image]');

    function currentSelections() {
      const sel = {};
      $$('.swatch.selected', root).forEach((s) => { sel[s.dataset.optionIndex] = s.dataset.value; });
      return sel;
    }
    function findVariant() {
      const sel = currentSelections();
      return variantsData.find((v) =>
        (sel['1'] === undefined || v.option1 === sel['1']) &&
        (sel['2'] === undefined || v.option2 === sel['2']) &&
        (sel['3'] === undefined || v.option3 === sel['3'])
      );
    }
    function render() {
      const v = findVariant();
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (priceEl) {
        let html = `<span class="price__now">${money(v.price)}</span>`;
        if (v.compare_at_price && v.compare_at_price > v.price) html += ` <span class="price__compare">${money(v.compare_at_price)}</span>`;
        priceEl.innerHTML = html;
      }
      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? addBtn.dataset.labelAdd : addBtn.dataset.labelSold;
      }
      // swap main gallery image to the selected variant's image
      if (mainImg && v.image) {
        mainImg.src = v.image;
        $$('[data-thumb]', root).forEach((t) => t.classList.toggle('active', t.dataset.full === v.image));
      }
      // reflect in URL
      if (history.replaceState) {
        const u = new URL(window.location);
        u.searchParams.set('variant', v.id);
        history.replaceState({}, '', u);
      }
    }

    root.addEventListener('click', (e) => {
      const sw = e.target.closest('.swatch');
      if (!sw || sw.classList.contains('unavailable')) return;
      const group = sw.closest('.swatches');
      $$('.swatch', group).forEach((s) => s.classList.remove('selected'));
      sw.classList.add('selected');
      render();
    });

    // thumbnail gallery
    $$('[data-thumb]', root).forEach((t) => {
      t.addEventListener('click', () => {
        $$('[data-thumb]', root).forEach((x) => x.classList.remove('active'));
        t.classList.add('active');
        if (mainImg) mainImg.src = t.dataset.full;
      });
    });

    render();
  });

  /* -------- Collection sort -------- */
  $$('[data-sort-select]').forEach((sel) => {
    sel.addEventListener('change', () => {
      const u = new URL(window.location);
      u.searchParams.set('sort_by', sel.value);
      u.searchParams.delete('page');
      window.location = u.toString();
    });
  });

  /* -------- Collection filters -------- */
  (function filters() {
    const form = document.querySelector('[data-filter-form]');
    if (!form) return;
    const aside = document.querySelector('[data-filters]');
    const openBtn = document.querySelector('[data-filter-open]');
    const backdrop = document.querySelector('.coll-filters__backdrop');
    const isDesktop = () => window.matchMedia('(min-width: 901px)').matches;

    const openDrawer = () => {
      aside.classList.add('is-open');
      if (backdrop) backdrop.hidden = false;
      document.body.classList.add('filters-open');
      if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
    };
    const closeDrawer = () => {
      aside.classList.remove('is-open');
      if (backdrop) backdrop.hidden = true;
      document.body.classList.remove('filters-open');
      if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
    };
    if (openBtn) openBtn.addEventListener('click', openDrawer);
    $$('[data-filter-close]').forEach((el) => el.addEventListener('click', closeDrawer));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeDrawer(); });

    // strip empty inputs so the URL stays clean, then drop pagination
    const submit = () => {
      $$('input[type="number"]', form).forEach((i) => { if (i.value === '') i.disabled = true; });
      const page = form.querySelector('[name="page"]');
      if (page) page.remove();
      form.submit();
    };

    // desktop: apply the moment a facet changes; mobile: wait for Apply
    form.addEventListener('change', (e) => {
      if (isDesktop() && e.target.matches('input[type="checkbox"], input[type="number"]')) submit();
    });
    form.addEventListener('submit', (e) => { e.preventDefault(); submit(); });
  })();

  /* -------- Jumbotron motion: scroll reveals + count-up -------- */
  (function motion() {
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) return;
    document.documentElement.classList.add('anim');

    const revealSel = '.section-head, .spotlight__inner, .iwt__media, .iwt__body, .stat, .value, .sport-tile, .card, .tile, .trust-item, .stats__grid';
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });

    $$(revealSel).forEach((el) => {
      el.classList.add('rv');
      const parent = el.parentNode;
      if (parent && (parent.classList.contains('grid') || parent.classList.contains('value-row') || parent.classList.contains('sports') || parent.classList.contains('trust-row') || parent.classList.contains('stats__grid'))) {
        const idx = Array.prototype.indexOf.call(parent.children, el);
        el.style.transitionDelay = (Math.min(idx, 10) * 55) + 'ms';
      }
      io.observe(el);
    });

    const cio = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) { countUp(e.target); cio.unobserve(e.target); } });
    }, { threshold: 0.4 });
    $$('[data-count]').forEach((el) => cio.observe(el));

    function countUp(el) {
      const raw = el.dataset.count || '0';
      const target = parseFloat(raw) || 0;
      const suffix = el.dataset.suffix || '';
      const dec = raw.indexOf('.') > -1 ? 1 : 0;
      const dur = 1500, start = performance.now();
      function tick(now) {
        const p = Math.min((now - start) / dur, 1);
        const eased = 1 - Math.pow(1 - p, 3);
        const val = target * eased;
        el.textContent = (dec ? val.toFixed(1) : Math.round(val)) + suffix;
        if (p < 1) requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
    }
  })();

  /* -------- Gameday countdown (counts up on reveal, then ticks live) -------- */
  $$('[data-countdown]').forEach((grid) => {
    const target = new Date(grid.dataset.countdown).getTime();
    if (isNaN(target)) return;
    const section = grid.closest('.countdown') || grid.parentNode;
    const units = {};
    $$('[data-unit]', grid).forEach((el) => { units[el.dataset.unit] = el; });
    const pad = (n) => String(n).padStart(2, '0');
    function compute() {
      const diff = target - Date.now();
      if (diff <= 0) return null;
      return {
        days: Math.floor(diff / 86400000),
        hours: Math.floor(diff / 3600000) % 24,
        minutes: Math.floor(diff / 60000) % 60,
        seconds: Math.floor(diff / 1000) % 60
      };
    }
    function render(v) {
      if (!v) { if (section) section.classList.add('countdown--done'); return false; }
      if (units.days) units.days.textContent = v.days;
      if (units.hours) units.hours.textContent = pad(v.hours);
      if (units.minutes) units.minutes.textContent = pad(v.minutes);
      if (units.seconds) units.seconds.textContent = pad(v.seconds);
      return true;
    }
    let started = false;
    function goLive() { render(compute()); setInterval(() => render(compute()), 1000); }
    function start() {
      if (started) return; started = true;
      const goal = compute();
      if (!goal) { render(null); return; }
      const dur = 1300, t0 = performance.now();
      (function anim(now) {
        const p = Math.min((now - t0) / dur, 1);
        const e = 1 - Math.pow(1 - p, 3);
        if (units.days) units.days.textContent = Math.round(goal.days * e);
        if (units.hours) units.hours.textContent = pad(Math.round(goal.hours * e));
        if (units.minutes) units.minutes.textContent = pad(Math.round(goal.minutes * e));
        if (units.seconds) units.seconds.textContent = pad(Math.round(goal.seconds * e));
        if (p < 1) requestAnimationFrame(anim); else goLive();
      })(performance.now());
    }
    if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      const cio = new IntersectionObserver((es) => {
        es.forEach((e) => { if (e.isIntersecting) { start(); cio.unobserve(e.target); } });
      }, { threshold: 0.4 });
      cio.observe(grid);
    } else {
      goLive();
    }
  });

  // init
  getCartState();
})();
